import { Wrapper, Box } from './PublicLayout.styled'

const PublicLayout = ({ children, justifyContent = 'flex-start', boxMinWidth = '360px' }) => {
  return (
    <Wrapper justifyContent={justifyContent}>
      <Box minWidth={boxMinWidth}>{children}</Box>
    </Wrapper>
  )
}

export default PublicLayout
